export interface TourStep {
    id: string;
    targetId: string;
    title: string;
    content: string;
    position?: 'top' | 'bottom' | 'left' | 'right' | 'center';
    path?: string; // Optional path to restrict step to a specific page
}

export const TOUR_VERSION = 2; // Incremented for new deep-tour experience

export const onboardingSteps: TourStep[] = [
    // --- HOME PAGE TOUR ---
    {
        id: 'welcome',
        targetId: 'welcome-center',
        title: 'Welcome to SightTrail Safaris',
        content: 'Your gateway to Africa. Let us show you how to navigate our high-end expedition system.',
        position: 'center',
        path: '/'
    },
    {
        id: 'filter-header',
        targetId: 'pricing-filter-trigger',
        title: 'Dynamic Pricing Control',
        content: 'Crucial: Set your nationality, group size, and tier here. The entire system will recalibrate pricing in real-time.',
        position: 'bottom',
        path: '/'
    },
    {
        id: 'category-matrix',
        targetId: 'all-categories-link',
        title: 'Expedition Categories',
        content: 'Filter by experience type: Safari, Wildlife, Photography, or Adventure. Each category is optimized for specific interests.',
        position: 'top',
        path: '/'
    },
    {
        id: 'featured-tours',
        targetId: 'tour-sample-category',
        title: 'Elite Selections',
        content: 'Hand-picked safaris currently trending. Tap any card to deep-dive into the itinerary.',
        position: 'top',
        path: '/'
    },


    // --- TOURS PAGE TOUR ---
    {
        id: 'tours-welcome',
        targetId: 'welcome-center',
        title: '🌍 All Safari Tours',
        content: 'Welcome to the expedition hub. Every package here is curated by Maasai-led specialists with deep local knowledge. Let\'s walk you through what you\'re looking at.',
        position: 'center',
        path: '/tours'
    },
    {
        id: 'tours-hub',
        targetId: 'tours-header',
        title: 'Search & Filter',
        content: 'Use the search bar and category filters above to narrow down your perfect expedition — by region, duration, or experience type.',
        position: 'bottom',
        path: '/tours'
    },
    {
        id: 'tour-pricing-sync',
        targetId: 'tour-sample-card',
        title: 'Live Pricing — No Surprises',
        content: 'Each card shows real pricing for your group. Select a tier — Luxury, Standard, or Budget — and the price updates instantly. No hidden costs at checkout.',
        position: 'bottom',
        path: '/tours'
    },
    {
        id: 'tours-card-cta',
        targetId: 'welcome-center',
        title: 'Ready to Explore?',
        content: 'Tap "View Details" on any tour card to dive deep into itineraries, inclusions, and pricing tiers. From there, you can instantly book or save for later.',
        position: 'center',
        path: '/tours'
    },

    // --- WIZARD / CHECKOUT TOUR ---
    {
        id: 'wizard-flow',
        targetId: 'wizard-steps-indicator',
        title: 'Secure Booking Pipeline',
        content: 'Our 5-step process captures traveler data, safari extras, and arrival intel with military precision.',
        position: 'bottom',
        path: 'wizard' // Matches any path containing 'wizard'
    },
    {
        id: 'whatsapp-auth',
        targetId: 'proceed-to-checkout-btn',
        title: 'WhatsApp Orchestration',
        content: 'At checkout, we trigger instant WhatsApp intel to both you and our logistics team for seamless coordination.',
        position: 'top',
        path: 'wizard'
    },

    // --- CLIENT DASHBOARD TOUR ---
    {
        id: 'my-bookings-intel',
        targetId: 'my-bookings-header',
        title: 'Mission Control: My Bookings',
        content: 'Track your scheduled expeditions and payment progress here. Your data is saved locally for privacy.',
        position: 'bottom',
        path: '/my-bookings'
    },

    // --- ADMIN TOUR ---
    {
        id: 'admin-telemetry',
        targetId: 'admin-sidebar',
        title: 'Admin Command Center',
        content: 'Manage tours, verify payments, and oversee logistics from this secure interface.',
        position: 'right',
        path: '/admin'
    }
];

/**
 * Registry to track if a path-specific tour has been dismissed
 */
export const getTourKeyForPath = (path: string) => `sighttrail_tour_v2_${path.replace(/\//g, '_')}`;
